<div
  class="bg-primary-500 text-base-1000 flex items-center justify-center rounded-[40px] px-[6px] py-[1px] text-[13px] font-medium leading-[15px]"
  [style.width.px]="width()"
  [style.height.px]="height()"
>
  {{ text() }}
</div>
